<template>
  <div class="max-w-3/4 mx-auto h-full grid grid-cols-6">
    <div
      class="col-start-1 col-span-6 md:col-span-3 lg:col-span-2 xl:col-span-2 flex content-center flex-wrap"
    >
      <div class="text-left">
        <p class="text-6xl font-hairline">We're lost.</p>
        <p class="text-4xl font-bold text-primary">Don't worry,</p>
        <p class="text-2xl font-bold">tell us, what are we looking for?</p>
        <div class="grid grid-rows-3 gap-6 mt-4">
          <div class="flex content-center flex-wrap">
            <button
              class="h-12 px-6 border border-gray-100 hover:border-secondary shadow-md inline-flex items-center justify-between w-full transition-all duration-500 ease-in-out transform hover:-translate-y-1 hover:bg-secondary rounded-lg hover:scale-105 font-semibold hover:font-bold hover:text-black"
            >
              <span class="tracking-widest">Estimate existing Deal</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="w-8 mr-4 icon-arrow-thin-right-circle"
              >
                <path
                  class="fill-current text-black"
                  d="M14.59 13H7a1 1 0 0 1 0-2h7.59l-2.3-2.3a1 1 0 1 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4l2.3-2.3z"
                />
              </svg>
            </button>
          </div>
          <div class="flex content-center flex-wrap">
            <button
              class="h-12 px-6 border border-gray-100 hover:border-secondary shadow-md inline-flex items-center justify-between w-full transition-all duration-500 ease-in-out transform hover:-translate-y-1 hover:bg-secondary rounded-lg hover:scale-105 font-semibold hover:font-bold hover:text-black"
            >
              <span class="tracking-widest">Estimate new Deal</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="w-8 mr-4 icon-arrow-thin-right-circle"
              >
                <path
                  class="fill-current text-black"
                  d="M14.59 13H7a1 1 0 0 1 0-2h7.59l-2.3-2.3a1 1 0 1 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4l2.3-2.3z"
                />
              </svg>
            </button>
          </div>
          <div class="flex content-center flex-wrap">
            <button
              class="h-12 px-6 border border-gray-100 hover:border-secondary shadow-md inline-flex items-center justify-between w-full transition-all duration-500 ease-in-out transform hover:-translate-y-1 hover:bg-secondary rounded-lg hover:scale-105 font-semibold hover:font-bold hover:text-black"
            >
              <span class="tracking-widest">Open existing Quote</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="w-8 mr-4 icon-arrow-thin-right-circle"
              >
                <path
                  class="fill-current text-black"
                  d="M14.59 13H7a1 1 0 0 1 0-2h7.59l-2.3-2.3a1 1 0 1 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4l2.3-2.3z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-start-1 md:col-start-4 lg:col-start-3 xl:col-start-3 col-span-6 md:col-span-3 lg:col-span-4 xl:col-span-4 flex content-center flex-wrap"
    >
      <img src="../../assets/img/not-found-2.png" alt="Logo Koehler" />
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>
